var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 141.732 141.732",
    width: "22px",
    height: "14px",
    id: "Livello_1",
    viewBox: "0 0 141.732 141.732",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.095,35.352c0,6.201-5.024,11.229-11.229,11.229c-6.203,0-11.229-5.028-11.229-11.229s5.027-11.23,11.229-11.23   C77.069,24.121,82.095,29.15,82.095,35.352 M106.217,35.352C106.217,15.828,90.39,0,70.867,0C51.343,0,35.515,15.828,35.515,35.352   c0,14.757,9.045,27.397,21.895,32.69v20.759l11.289,5.645l-11.289,5.646v3.24l11.289,5.646l-11.289,5.646v3.239l11.289,5.646   l-11.289,5.645v1.488l13.457,10.783l13.458-10.783V68.043C97.172,62.75,106.217,50.109,106.217,35.352"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1_1_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.603681b9ce47a3f3baa0369f40a9d930.svg";
export { ForwardRef as ReactComponent };